// app/utils/catalogRoute.ts
// Shared parsing for the catalog route catch-all, which may carry a tag-suffix:
//   /catalog/ukhod_za_litsom/tags/protiv-vospaleniy,uvlazhnenie
// The `tags` segment separates the section path from the comma-joined tag slugs.

/** Path segment that separates a catalog section path from tag slugs. */
export const TAGS_SEGMENT = 'tags';

export interface ParsedCatalogPath {
  /** Section path segments before the tags sentinel, e.g. ['ukhod_za_litsom']. */
  sectionSegments: string[];
  /** Tag slugs after the tags sentinel (comma-split), e.g. ['protiv-vospaleniy']. */
  tagSlugs: string[];
}

/** Split a `[...categories]` catch-all value into section segments + tag slugs. */
export const parseCatalogPath = (segments: unknown): ParsedCatalogPath => {
  const arr: string[] = Array.isArray(segments) ? segments.filter(Boolean) : segments ? [String(segments)] : [];
  const tagsIdx = arr.indexOf(TAGS_SEGMENT);
  if (tagsIdx === -1) {
    return { sectionSegments: arr, tagSlugs: [] };
  }
  const sectionSegments = arr.slice(0, tagsIdx);
  const tagPart = arr.slice(tagsIdx + 1).join(',');
  const tagSlugs = tagPart ? tagPart.split(',').filter(Boolean) : [];
  return { sectionSegments, tagSlugs };
};
